import { Controller } from "react-hook-form";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Chip,
  Checkbox,
  FormControlLabel
} from "@mui/material";

export const CustomControlledInput = ({
  name,
  control,
  label,
  placeholder,
  type = "text",
  options = [],
  multiple = false,
  helperText,
  readOnly = false,
  formatOnBlur,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={type === "checkbox" ? false : multiple ? [] : ""}
      render={({ field, fieldState }) => {
        if (type === "select") {
          const renderValue = multiple
            ? (selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((val, idx) => {
                    const opt = options.find((o) => o.value === val);
                    return <Chip key={`${val ?? 'empty'}-${idx}`} label={opt?.label || val} size="small" />;
                  })}
                </Box>
              )
            : undefined;

          return (
            <FormControl fullWidth error={!!fieldState.error}>
              <InputLabel>{label}</InputLabel>
              <Select
                {...field}
                value={field.value ?? (multiple ? [] : "")}
                onChange={(e) => field.onChange(e.target.value ?? (multiple ? [] : ""))}
                multiple={multiple}
                label={label}
                renderValue={renderValue}
                {...props}
              >
                {options.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
              {fieldState.error && (
                <Typography variant="caption" color="error">
                  {fieldState.error.message}
                </Typography>
              )}
            </FormControl>
          );
        }

        if (type === "checkbox") {
          return (
            <Box>
              <FormControlLabel
                control={<Checkbox {...field} checked={field.value} {...props} />}
                label={label}
              />
              {fieldState.error && (
                <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                  {fieldState.error.message}
                </Typography>
              )}
            </Box>
          );
        }

        return (
          <TextField
            {...field}
            {...props}
            fullWidth
            label={label}
            placeholder={placeholder}
            type={type}
            error={!!fieldState.error}
            helperText={fieldState.error?.message || helperText}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => field.onChange(e.target.value)}
          />
        );
      }}
    />
  );
};